import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=52b7d136&scoped=true&"
import script from "./ProjectStatus.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProjectStatus.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7d136",
  null
  
)

export default component.exports